import { CompaniesIcon } from 'foundations-assets';
import { IconContainer } from './IconContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const IconCompanies = props => /*#__PURE__*/_jsx(IconContainer, Object.assign({}, props, {
  children: /*#__PURE__*/_jsx(CompaniesIcon, {})
}));